import React, { useState } from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useMutation } from "@apollo/client";
import { addModuleFunctionalityOrderMutation } from "./ModulesGqlQuery";

const AddModuleFunctionality = (props) => {
  const [addFunctionality] = useMutation(addModuleFunctionalityOrderMutation);
  const [moduleDisplayName, setModuleDisplayName] = useState("");
  const [moduleName, setModuleName] = useState("");

  const [portal, setPortal] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const moduleNameValue = moduleName.trim();
    const moduleDisplayNameValue = moduleDisplayName.trim();

    if (!moduleNameValue || !moduleDisplayNameValue || !portal) {
      return;
    }

    addFunctionality({
      variables: {
        functionality: {
          moduleId : parseInt(props.moduleId),
          functionalityName: moduleNameValue,
          functionalityDisplayName: moduleDisplayNameValue,
          functionalityPortal :portal,
        },
      },
    })
      .then(() => {
        if (props.onSuccess) {
          props.onSuccess({
            moduleName: moduleNameValue,
            moduleDisplayName: moduleDisplayNameValue,
          });
        }
      })
      .catch((error) => {
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          setErrorMessage(error.graphQLErrors[0].message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <DialogContent>
        <TextField
          label="Functionality Name"
          value={moduleName}
          onChange={(event) => {
            setModuleName(event.target.value);
          }}
          variant="outlined"
          size="small"
          fullWidth
          //   autoFocus
          style={{ marginBottom: 16 }}
        />
        <TextField
          label="Functionality Display Name"
          value={moduleDisplayName}
          onChange={(event) => {
            setModuleDisplayName(event.target.value);
          }}
          variant="outlined"
          size="small"
          fullWidth
          //   autoFocus
        />

        <FormControl
          variant="outlined"
          size="small"
          fullWidth
          style={{ marginTop: 16 }}
        >
          <InputLabel id="portal-label">Portal</InputLabel>
          <Select
            labelId="portal-label"
            value={portal}
            onChange={(event) => setPortal(event.target.value)}
            label="Portal"
          >
            <MenuItem value="SBIZZL">SBIZZL</MenuItem>
            <MenuItem value="CUSTOMER_PORTAL">CUSTOMER PORTAL</MenuItem>
          </Select>
        </FormControl>

        {errorMessage && (
          <div style={{ color: "red", marginTop: 8 }}>{errorMessage}</div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Cancel
        </Button>

        <Button
          type="submit"
          color="primary"
          disabled={!moduleName.trim() || !moduleDisplayName.trim() || !portal}
        >
          Save
        </Button>
      </DialogActions>
    </form>
  );
};

export default AddModuleFunctionality;
